export enum SelectorIdTrackingEnum {
    USAGE = 'Q2WYSnp8',
    CONTRACT = 'mtROCNJY',
}
